import Vue from 'vue';
import Component from 'vue-class-component';
import Device from "@/components/status/Device";
import {AXIOS} from "@/lib/http-common";
import {EVENTBUS_TOPICS, STOMP_TOPICS} from "@/lib/constants";
import {Message, Subscription} from "webstomp-client";
import {DeviceStatus} from "@/components/device/DeviceStatus";
import StatusIndicator from "@/views/status/StatusIndicator.vue";
import {EventBus} from "@/lib/event-bus";

@Component({
  computed: {
    DeviceStatus() {
      return DeviceStatus;
    }
  },
  components: {
    StatusIndicator
  }
})
export default class DeviceStatusView extends Vue {
  public deviceList: Device[] = [];
  public deviceStatusSub!: Subscription;

  public mounted() {
    this.getDeviceList();

    EventBus.$on(EVENTBUS_TOPICS.WEBSOCKET_CONNECTED, this.websocketConnected);
    this.websocketConnected(this.$store.state.stompClient.connected);
  }

  public getDeviceList() {
    AXIOS.get("/device")
      .then((message) => {
        this.deviceList = message.data;
      });
  }

  public websocketConnected(state: boolean) {
    if (state) {
      this.deviceStatusSub = this.$store.state.stompClient.subscribe(
        STOMP_TOPICS.DEVICE_STATUS,
        (message: Message) => {
          const deviceFromMessage: Device = JSON.parse(message.body);
          const storedDevice: Device | undefined = this.deviceList.find(device => device.deviceName === deviceFromMessage.deviceName);
          if (storedDevice) {
            storedDevice.status = deviceFromMessage.status;
            this.$store.dispatch("updateCubiscanConnected", storedDevice.status === DeviceStatus.POSITIVE);
          }
        }
      );
      return;
    } else {
      this.deviceList.forEach(device => {
        device.status = DeviceStatus.DISABLED;
        this.$store.dispatch("updateCubiscanConnected", false);
      });
    }
  }

  public beforeDestroy() {
    EventBus.$off(EVENTBUS_TOPICS.WEBSOCKET_CONNECTED, this.websocketConnected);

    if (this.deviceStatusSub !== undefined) {
      this.deviceStatusSub.unsubscribe();
    }
  }
}
